import { render, staticRenderFns } from "./horizontal.vue?vue&type=template&id=784e5516"
import script from "./horizontal.vue?vue&type=script&lang=ts"
export * from "./horizontal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports